(function () {
  const SECTION_SELECTOR = '.it-projects-grid';
  const TITLE_SELECTOR = '.projects-grid__title';
  const TYPE_SPEED = 85;
  const TYPE_START_DELAY = 200;

  function prepareTypedSpan(section) {
    const title = section.querySelector(TITLE_SELECTOR);

    if (!title) {
      return null;
    }

    const span = title.querySelector('span');

    if (!span) {
      return null;
    }

    const source = span.textContent || '';

    if (!source) {
      return null;
    }

    span.dataset.typedSource = source;
    span.innerHTML = '';

    return span;
  }

  function typeSpan(span) {
    if (!span || span.dataset.typedStarted === 'true') {
      return;
    }

    const source = span.dataset.typedSource || '';

    if (!source) {
      return;
    }

    span.dataset.typedStarted = 'true';

    let charIndex = 0;

    function tick() {
      charIndex += 1;
      span.textContent = source.slice(0, charIndex);

      if (charIndex < source.length) {
        window.setTimeout(tick, TYPE_SPEED);
      }
    }

    tick();
  }

  function initSection(section) {
    const fadeElements = section.querySelectorAll('.fade-up');
    const typedSpan = prepareTypedSpan(section);

    if (!fadeElements.length) {
      return;
    }

    section.classList.add('is-reveal-ready');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');

        if (typedSpan && entry.target.matches(TITLE_SELECTOR)) {
          window.setTimeout(() => {
            typeSpan(typedSpan);
          }, TYPE_START_DELAY);
        }

        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.16,
      rootMargin: '0px 0px -8% 0px',
    });

    fadeElements.forEach((element, index) => {
      element.style.transitionDelay = `${index * 100}ms`;
      observer.observe(element);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      initSection(section);
    });
  });
})();
